export const darkTheme = {
  isDark: true,
  fontColor: '#f5f5f5',
  background: '#191919',
  navColor: 'rgba(16, 16, 16, 0.85)',
  colorOne: '#262626',
  colorTwo: '#2b2b2b',
  cardBg: '#222222',
  muted: '#9aa0a6',
  border: 'rgba(255, 255, 255, 0.08)',
  accent: '#01bf71',
  accentHover: '#02d981',
  shadow: '0 10px 30px rgba(0, 0, 0, 0.4)',
};

export const lightTheme = {
  isDark: false,
  fontColor: '#1a1a1a',
  background: '#E3D7F1',
  navColor: 'rgba(217, 190, 201, 0.85)',
  colorOne: '#D9BEC9',
  colorTwo: '#ffffff',
  cardBg: '#ffffff',
  muted: '#6b6b6b',
  border: 'rgba(60, 40, 80, 0.12)',
  accent: '#01bf71',
  accentHover: '#02a862',
  shadow: '0 10px 30px rgba(80, 60, 110, 0.18)',
};
